import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardLayout from '@/views/Dashboard.vue'
import Dashboard from '@/pages/Dashboard.vue'
import Login from '@/views/Login.vue'
import store from '@/store/index'
import i18n, { languages } from '@/plugins/i18n'

Vue.use(VueRouter)
var currentLang = store.getters.locale
var isChangeLang = false

const checkLanguage = (to, from, next) => {
  let lang = to.params.lang
  if (languages.some((v) => to.path.includes(v))) {
    if (store.getters.locale != lang) {
      isChangeLang = true
      currentLang = lang
    }

    if ('/' + currentLang == to.fullPath) {
      next('/' + currentLang + '/dashboard')
    } else {
      next()
    }
  } else {
    next('/' + store.getters.locale + to.fullPath)
  }
}

const ifAuthenticated = (to, from, next) => {
  store.dispatch('tryLogin')
  checkLanguage(to, from, next)
}
const routes = [
  {
    path: '/login',
    name: 'LOGIN_TITLE',
    component: Login,
    // beforeEnter: checkLanguage,
  },
  {
    path: '/',
    name: 'root',
    beforeEnter(to, from, next) {
      next(store.getters.locale + '/dashboard')
    },
  },
  {
    path: '/:lang',
    name: 'MAIN_PAGE',
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: 'dashboard',
        name: 'DASHBOARD',
        component: Dashboard,
      },
      {
        path: 'drivers/add',
        name: 'ADD_DRIVER',
        component: () => import('@/pages/drivers/newAdd.vue'),
      },
      {
        path: 'drivers/list',
        name: 'DRIVER_LIST',
        component: () => import('@/pages/drivers/list.vue'),
      },
      {
        path: 'drivers/edit/:id',
        name: 'EDIT_DRIVER',
        component: () => import('@/pages/drivers/edit.vue'),
      },
      {
        path: 'drivers/view/:id',
        name: 'VIEW_DRIVER',
        component: () => import('@/pages/drivers/edit.vue'),
      },
      {
        path: 'drivers-leaves/add',
        name: 'ADD_DRIVER_LEAVE',
        component: () => import('@/pages/drivers-leaves/add.vue'),
      },
      {
        path: 'drivers-leaves/list',
        name: 'DRIVER_LEAVES_LIST',
        component: () => import('@/pages/drivers-leaves/list.vue'),
      },
      {
        path: 'drivers-leaves/edit/:id',
        name: 'EDIT_DRIVER_LEAVE',
        component: () => import('@/pages/drivers-leaves/edit.vue'),
      },
      {
        path: 'drivers-leaves/view/:id',
        name: 'VIEW_DRIVER_LEAVE',
        component: () => import('@/pages/drivers-leaves/edit.vue'),
      },

      {
        path: 'cars/add',
        name: 'ADD_VEHICLE',
        component: () => import('@/pages/cars/newAdd.vue'),
      },
      {
        path: 'cars/edit/:id',
        name: 'EDIT_VEHICLE',
        component: () => import('@/pages/cars/edit.vue'),
      },
      {
        path: 'cars/view/:id',
        name: 'VIEW_VEHICLE',
        component: () => import('@/pages/cars/edit.vue'),
      },
      {
        path: 'cars/list',
        name: 'VEHICLE_LIST',
        component: () => import('@/pages/cars/list.vue'),
      },

      {
        path: 'fuel-card/add',
        name: 'ADD_FUEL',
        component: () => import('@/pages/fuel-card/add.vue'),
      },
      {
        path: 'fuel-card/transactions/list',
        name: 'transactions_list',
        component: () => import('@/pages/fuel-card/transaction-list.vue'),
      },
      {
        path: 'fuel-card/edit/:id',
        name: 'EDIT_FUEL',
        component: () => import('@/pages/fuel-card/edit.vue'),
      },
      {
        path: 'fuel-card/view/:id',
        name: 'VIEW_FUEL',
        component: () => import('@/pages/fuel-card/edit.vue'),
      },
      {
        path: 'fuel-card/list',
        name: 'FUEL_LIST',
        component: () => import('@/pages/fuel-card/list.vue'),
      },

      {
        path: 'service/add',
        name: 'ADD_SERVICE',
        component: () => import('@/pages/service/add.vue'),
      },
      {
        path: 'service/edit/:id',
        name: 'EDIT_SERVICE',
        component: () => import('@/pages/service/edit.vue'),
      },
      {
        path: 'service/view/:id',
        name: 'VIEW_SERVICE',
        component: () => import('@/pages/service/edit.vue'),
      },
      {
        path: 'service/list',
        name: 'VEHICLE_SERVICE_LIST',
        component: () => import('@/pages/service/list.vue'),
      },

      {
        path: 'geofence/add',
        name: 'ADD_GEOFENCE',
        component: () => import('@/pages/geofence/add.vue'),
      },
      {
        path: 'geofence/edit/:id',
        name: 'EDIT_GEOFENCE',
        component: () => import('@/pages/geofence/edit.vue'),
      },
      {
        path: 'geofence/view/:id',
        name: 'VIEW_GEOFENCE',
        component: () => import('@/pages/geofence/view.vue'),
      },
      {
        path: 'geofence/list',
        name: 'GEOFENCE_LIST',
        component: () => import('@/pages/geofence/list.vue'),
      },

      {
        path: 'company/profile',
        name: 'COMPANY_PROFILE',
        component: () => import('@/pages/company/profile.vue'),
      },
      {
        path: 'setting/change-password',
        name: 'CHANGE_PASSWORD',
        component: () => import('@/pages/setting/password.vue'),
      },
      {
        path: 'reminders',
        name: 'REMINDERS',
        component: () => import('@/pages/global/reminders.vue'),
      },

      {
        path: 'devices/list',
        name: 'DEVICES_LIST',
        component: () => import('@/pages/devices/list.vue'),
      },
      {
        path: 'reports/realtime',
        name: 'REALTIME_REPORT',
        component: () => import('@/pages/realtime.vue'),
      },
      {
        path: 'reports/history/driver',
        name: 'HISTORY_REPORT_DRIVER',
        component: () => import('@/pages/reports/history/driver.vue'),
      },
      {
        path: 'reports/history/hardware',
        name: 'HISTORY_REPORT_HARDWARE',
        component: () => import('@/pages/reports/history/hardware.vue'),
      },
      {
        path: 'reports/history/stops',
        name: 'HISTORY_REPORT_STOPS',
        component: () => import('@/pages/reports/history/stops.vue'),
      },
      {
        path: 'reports/history/routing',
        name: 'HISTORY_ROUTES',
        component: () => import('@/pages/reports/history/routing.vue'),
      },
      {
        path: 'reports/daily',
        name: 'DAILY_REPORT',
        component: () => import('@/pages/reports/daily.vue'),
      },
      {
        path: 'reports/history/routing-details',
        name: 'HISTORY_ROUTES_LIST',
        component: () => import('@/pages/reports/history/routingList.vue'),
      },
      {
        path: 'reports/periodic',
        name: 'REPORT_periodic',
        component: () => import('@/pages/reports/periodic/index.vue'),
      },
      {
        path: 'reports/history/overview',
        name: 'REPORT_OVERVIEW',
        component: () => import('@/pages/reports/history/overview.vue'),
      },
      {
        path: 'reports/history/overview/details/:id',
        name: 'TRIP_DETAIL_',
        component: () => import('@/pages/reports/history/overview-details.vue'),
      },

      // V2
      {
        path: 'reports/history/v2overview',
        name: 'REPORT_OVERVIEW_v2',
        component: () => import('@/pages/reports/history/v2overview.vue'),
      },
      {
        path: 'reports/history/v2overview/details/:id',
        name: 'TRIP_DETAIL_v2',
        component: () =>
          import('@/pages/reports/history/v2overview-details.vue'),
      },

      {
        path: 'reports/history/routing/:id',
        name: 'TRIP_DETAIL',
        component: () => import('@/pages/reports/history/tripDetail.vue'),
      },
      {
        path: 'reports/realtime/routing/:id',
        name: 'REALTIME_TRIP',
        component: () => import('@/pages/reports/RealtimeRouting.vue'),
      },
      {
        path: 'reports/geofence-rules',
        name: 'GEOFENCE_RULES',
        component: () => import('@/pages/reports/geofence-rules.vue'),
      },
      {
        path: 'reports/geofence-rules/:id',
        name: 'GEOFENCE_RULES_DETAIL',
        component: () => import('@/pages/reports/geofence-detail.vue'),
      },
      {
        path: 'reports/realtime/temperature',
        name: 'REALTIME_temperature',
        component: () => import('@/pages/reports/realtime/temperature.vue'),
      },
      {
        path: 'reports/rules',
        name: 'REPORT_RULES_LIST',
        component: () => import('@/pages/reports/rules.vue'),
      },
      {
        path: 'reports/rules/:id',
        name: 'REPORT_RULES_DETAIL',
        component: () => import('@/pages/reports/rules-detail.vue'),
      },

      {
        path: 'tags/list',
        name: 'tags_list',
        component: () => import('@/pages/tags/list.vue'),
      },
      {
        path: 'tags/add',
        name: 'add_tag',
        component: () => import('@/pages/tags/add.vue'),
      },
      {
        path: 'tags/edit/:id',
        name: 'edit_tag',
        component: () => import('@/pages/tags/edit.vue'),
      },
      {
        path: 'tags/view/:id',
        name: 'view_tag',
        component: () => import('@/pages/tags/edit.vue'),
      },
      {
        path: 'reporting',
        name: 'ANALYTICS_REPORTING',
        component: () => import('@/pages/reporting/index.vue'),
      },

      {
        path: 'rules/list',
        name: 'RULES_LIST',
        component: () => import('@/pages/conditions/list.vue'),
      },
      {
        path: 'rules/add',
        name: 'RULES_ADD',
        component: () => import('@/pages/conditions/add.vue'),
      },
      {
        path: 'rules/edit/:id',
        name: 'RULES_EDIT',
        component: () => import('@/pages/conditions/edit.vue'),
      },
      {
        path: 'rules/view/:id',
        name: 'RULES_VIEW',
        component: () => import('@/pages/conditions/edit.vue'),
      },

      {
        path: 'plans/evaluation',
        name: 'PLANS_EVALUATION',
        component: () => import('@/pages/plans/evaluation.vue'),
      },

      {
        path: 'users/approvals',
        name: 'approvals_list',
        component: () => import('@/pages/approvals/list.vue'),
      },

      // {
      //   path: 'locations/list',
      //   name: 'LOCATIONS_LIST',
      //   component: () => import('@/pages/locations/list.vue'),
      // },
      // {
      //   path: 'locations/add',
      //   name: 'LOCATIONS_ADD',
      //   component: () => import('@/pages/locations/add.vue'),
      // },
      // {
      //   path: 'locations/edit/:id',
      //   name: 'LOCATIONS_EDIT',
      //   component: () => import('@/pages/locations/edit.vue'),
      // },
      // {
      //   path: 'locations/view/:id',
      //   name: 'LOCATIONS_VIEW',
      //   component: () => import('@/pages/locations/edit.vue'),
      // },

      {
        path: 'organizations/add',
        name: 'ADD_ORGANIZATION',
        component: () => import('@/pages/organizations/add.vue'),
      },
      {
        path: 'organizations/list',
        name: 'ORGANIZATION_LIST',
        component: () => import('@/pages/organizations/list.vue'),
      },
      {
        path: 'organizations/edit/:id',
        name: 'EDIT_ORGANIZATION',
        component: () => import('@/pages/organizations/edit.vue'),
      },
      {
        path: 'organizations/view/:id',
        name: 'VIEW_ORGANIZATION',
        component: () => import('@/pages/organizations/edit.vue'),
      },

      {
        path: 'users/add',
        name: 'ADD_USER',
        component: () => import('@/pages/users/add.vue'),
      },
      {
        path: 'users/edit/:id',
        name: 'EDIT_USER',
        component: () => import('@/pages/users/edit.vue'),
      },
      {
        path: 'users/view/:id',
        name: 'VIEW_USER',
        component: () => import('@/pages/users/edit.vue'),
      },
      {
        path: 'users/list',
        name: 'USERS_LIST',
        component: () => import('@/pages/users/list.vue'),
      },
      //

      {
        path: 'fines/add',
        name: 'ADD_FINES',
        component: () => import('@/pages/fines/add.vue'),
      },
      {
        path: 'fines/edit/:id',
        name: 'EDIT_FINES',
        component: () => import('@/pages/fines/edit.vue'),
      },
      {
        path: 'fines/view/:id',
        name: 'VIEW_FINES',
        component: () => import('@/pages/fines/edit.vue'),
      },
      {
        path: 'fines/list',
        name: 'FINES_LIST',
        component: () => import('@/pages/fines/list.vue'),
      },

      {
        path: '*',
        name: 'ERROR_NOTFOUND',
        component: () => import('@/views/404.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

const DEFAULT_TITLE = 'CARPO'
router.afterEach((to) => {
  store.commit('OPEN_NAVBAR', false)
  document.body.classList.remove('overflow-y-hidden')
  if (isChangeLang) {
    store.dispatch('changeLocale', currentLang)
  }
  let defaultLang = to.params.lang == undefined ? currentLang : to.params.lang
  // i18n.locale = defaultLang;

  Vue.nextTick(() => {
    document.title =
      to.name != undefined && to.path != '/login'
        ? i18n.messages[defaultLang][to.name] +
          ' | ' +
          i18n.messages[defaultLang][DEFAULT_TITLE]
        : i18n.messages[defaultLang][to.name]
  })
})

export default router
